// Module
var code = "<cu-page-frame fluid> <cu-page-frame-main> <cu-page-frame-content class=\"cu-p-0\"> <div class=\"cu-w-100\"> <div class=\"welcome-screen-card-section cu-d-flex cu-flex-column cu-align-items-center\"> <onboarding-screen class=\"cu-w-100\"></onboarding-screen> </div> </div> </cu-page-frame-content> </cu-page-frame-main> </cu-page-frame> ";
// Exports
module.exports = code;